import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  const script = document.createElement('script');
  script.src = './newrelic.js';
  document.head.appendChild(script);
  console.log("loading newrelic");
}else{
  console.log("newrelic inactive");
}

const prefix = environment.production ? '' : '__dev_';
const script = document.createElement('script');
script.src = `https://cdn.waypoint.cl/js/${prefix}tranciti-navbar.js`;
script.type = 'module';
document.head.appendChild(script);

// Tokens del design system de Tranciti, para el aviso de la nueva
// Localización Instantánea (TELE-710).
const tokens = document.createElement('link');
tokens.rel = 'stylesheet';
tokens.href = `https://cdn.waypoint.cl/ui-ux/${prefix}tokens.css`;
document.head.appendChild(tokens);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
